import { PostCard } from '../components/PostCard.js';
import { POSTS } from '../posts.js';

/**
 * The /blogs/ index page. Reading-list layout (not a card grid)
 * inside `max-w-prose` so the page reads with the same rhythm
 * as the post bodies it links to. Newest first; empty state is
 * intentional and minimal — a missing first post is information,
 * not an error to apologize for.
 */
export function BlogIndex(): JSX.Element {
  return (
    <section id="top" aria-labelledby="blog-index-h1" className="border-b border-border">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-8 md:py-24">
        <header className="mx-auto max-w-prose">
          <p className="font-mono text-xs uppercase tracking-widish text-muted">~/memento/blogs</p>
          <h1
            id="blog-index-h1"
            className="mt-4 text-4xl font-medium leading-tight tracking-tight text-fg md:text-6xl"
          >
            Notes on memory, MCP, and tools that share.
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-fg/80">
            Field notes from building a local-first memory layer that follows you across every AI
            assistant you use. Opinion-led, technically honest, and updated as the MCP ecosystem
            moves.
          </p>
        </header>
        <div className="mx-auto mt-16 max-w-prose">
          {POSTS.length === 0 ? (
            <p className="font-mono text-sm text-muted">No posts yet. First one is in flight.</p>
          ) : (
            POSTS.map((post) => <PostCard key={post.slug} post={post} />)
          )}
        </div>
      </div>
    </section>
  );
}
